import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import AIAgentLoader from "./AIAgentLoader";
import { LogOut } from "lucide-react";

export default function Header({ pageTitle, pageDescription }) {
  const { user, logout } = useAuth();
  const [isRunning, setIsRunning] = useState(false);
  const [dataSource, setDataSource] = useState("mock");

  const load = async () => {
    try {
      const [s, sum] = await Promise.all([api.status(), api.summary()]);
      setIsRunning(!!s?.is_running);
      setDataSource(sum?.data_source || "mock");
    } catch (e) {
      console.error("status load failed", e);
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <>
      <AIAgentLoader
        open={isRunning}
        title="AI Agent is scanning your cloud"
        subtitle="Discovering waste across BigQuery, Compute, GKE, Vertex AI, Cloud SQL, IAM, Pub/Sub & more."
      />
      <header
        data-testid="app-header"
        className="sticky top-0 z-30 bg-white border-b border-border"
      >
        <div className="px-6 lg:px-10 py-5 flex items-center justify-between gap-4">
          <div className="min-w-0">
            <h1
              className="cs-heading text-2xl font-semibold tracking-tight text-foreground"
              data-testid="page-title"
            >
              {pageTitle}
            </h1>
            {pageDescription && (
              <p className="text-sm text-muted-foreground mt-0.5">{pageDescription}</p>
            )}
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {dataSource === "live" && (
              <span
                data-testid="data-source-pill"
                className="cs-pill bg-[#dcfce7] text-[#15803d] cs-mono text-[10px]"
                title="Reading from your live GCP BigQuery billing export"
              >
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#15803d] animate-pulse" />
                LIVE
              </span>
            )}
            {user && (
              <button
                onClick={logout}
                data-testid="logout-button"
                title={`Signed in as ${user.email} — sign out`}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-sm border border-border text-xs text-muted-foreground hover:text-foreground hover:bg-[hsl(var(--cs-tint))] transition-colors duration-200"
              >
                <LogOut className="w-3.5 h-3.5" />
                Sign out
              </button>
            )}
          </div>
        </div>
      </header>
    </>
  );
}
